import React from 'react';
import GraphqlTable from 'cccisd-graphql-table';
import { assessmentPlans, responseFlags } from '../renders';
import learnersQuery from './learners.graphql';
import PageHeader from '../../../components/PageHeader';
import style from '../style.css';

const now = new Date();

const SiteAdminDash = () => {
    const renders = {
        totalAssessmentPlans: t => {
            const studentName = t.row['fields.firstName'] + ' ' + t.row['fields.lastName'];

            return assessmentPlans({
                planList: t.row.selectedAssignmentPlanList,
                context: studentName,
                adjustColumns: c => {
                    return c.filter(col => col.label !== 'Actions' && col.name !== 'selectedByPawnList');
                },
            });
        },
        activeAssessmentPlans: t => {
            const plans = t.row.selectedAssignmentPlanList;
            const studentName = t.row['fields.firstName'] + ' ' + t.row['fields.lastName'];

            return assessmentPlans({
                planList: plans.filter(plan => plan.openSessions.length > 0),
                context: studentName,
                adjustColumns: c => {
                    return c.filter(col => col.label !== 'Actions' && col.name !== 'selectedByPawnList');
                },
            });
        },
        responseFlags: t => {
            const learnerList = [t.row];
            const studentName = t.row['fields.firstName'] + ' ' + t.row['fields.lastName'];

            return responseFlags({ row: t.row, learnerList, context: studentName });
        },
    };

    return (
        <>
            <div style={{ background: '#fff' }} className="container">
                <PageHeader
                    title="Admin Dashboard"
                    description="View assessment plan activity for every student in your school"
                />
                <div style={{ background: '#fff', textAlign: 'center' }} className={style.dashboardWrapper}>
                    <GraphqlTable
                        query={learnersQuery}
                        graphqlVariables={{
                            today: now.toJSON(),
                            orderBy: [
                                {
                                    field: 'pawn.pawnId',
                                    direction: 'ASC',
                                },
                            ],
                        }}
                        rowKey="pawn.pawnId"
                        renders={renders}
                        columns={[
                            { name: 'pawn.pawnId', label: 'Pawn Id', hideInTable: true },
                            {
                                name: 'studentId',
                                label: 'Student ID',
                                filter: true,
                                sort: true,
                                render: v => v.row['fields.studentId'],
                            },
                            {
                                name: 'name',
                                label: 'Name',
                                filter: true,
                            },
                            {
                                name: 'selectedAssignmentPlanCount',
                                label: 'Total Assessment Plans',
                                tooltip: 'Assessment Plans that this student has participated in',
                                render: 'totalAssessmentPlans',
                            },
                            {
                                name: 'activeAssessmentPlanCount',
                                label: 'Active Assessment Plans',
                                tooltip: 'Number of Assessment Plans that are currently open',
                                render: 'activeAssessmentPlans',
                            },
                            {
                                name: 'parentRoles.instructor.user.fullNameWithUsername',
                                label: 'Provider',
                                sort: true,
                                filter: true,
                            },
                            {
                                name: 'flagCount',
                                label: 'Response Flags',
                                sort: true,
                                render: 'responseFlags',
                            },
                        ]}
                        csvFilename="students"
                    />
                </div>
            </div>
        </>
    );
};

export default SiteAdminDash;
